import { Card } from '@mui/material';
import { useSearchParams, useNavigate } from 'react-router-dom';
import useBudgetVersion from '../hooks/useBudgetVersion';
import CreateBudget from '../../createAndEdit';
import DetailBudget from '../../detail';
import { Loading } from '../../../../utils/loading';

const BudgetVersion = (props: any) => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const redirectBack = searchParams.get('redirectBack');
    const { budgetVersion, budget, viewMode, loading, afterSave } = useBudgetVersion({ mainRoute: `/${props.persona}` });

    const handleClose = () => {
        if (redirectBack) {
            navigate(redirectBack);
        } else {
            afterSave();
        }
    };

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <Loading label="Carregando orçamento..." />
            </div>
        );
    }

    return (
        <Card className="p-8 my-4">
            {viewMode === 'update' || viewMode === 'create' ?
                <CreateBudget
                    mode={viewMode === 'create' ? 'create' : 'edit'}
                    budgetId={budgetVersion?.budgetId || 'budget-' + Date.now()}
                    initialData={budgetVersion || undefined}
                    occurrenceId={budgetVersion?.occurrenceId}
                    onSave={afterSave}
                    onClose={redirectBack ? handleClose : undefined}
                    redirectBack={redirectBack || undefined}
                />
            :
            <DetailBudget
                occurrenceId={budgetVersion?.occurrenceId || ''}
                budgetId={budgetVersion?.budgetId || ''}
                initialData={budgetVersion || undefined}
                budgetStatus={budget?.status}
                onClose={redirectBack ? handleClose : undefined}
                redirectBack={redirectBack || undefined}
            />}
        </Card>
    );
};

export default BudgetVersion;